import { FC, ReactNode } from "react";

import { NavLink } from "@/components/_molecules/navigation-controls/nav-link";

interface SidebarHeaderElementProps {
  to: string;
  children: ReactNode;
}

export const SidebarHeaderElement: FC<SidebarHeaderElementProps> = ({ to, children }) => {
  return (
    <div className="relative rounded-md">
      <NavLink to={to} className="text-sm text-muted-foreground">
        <span className="relative flex h-8 items-center overflow-hidden text-ellipsis rounded-md pb-0 pl-1.5 pr-0.5 pt-0">
          {children}
        </span>
      </NavLink>
    </div>
  );
};
